import InterfaceArrowsButtonDown from '@streamlinehq/streamlinehq/img/streamline-micro-line/interface-essential/arrows/interface-arrows-button-down.svg';
import { Column } from '@tanstack/react-table';
import { BouSvgIcon } from '@upright/ui/common/generic/components/bou-svg-icon';
import { BouCheckBoxWithLabel } from '@upright/ui/common/generic/components/inputs/bou-check-box-with-label';
import CustomTippyTooltip from '@upright/ui/common/generic/components/tooltips/custom-tippy-tooltip/default-tooltip';
import { BouColor } from '@upright/ui/common/generic/global/bou-colors';
import { BouSpacingLevel, fluidSpacing } from '@upright/ui/common/generic/layout/bou-spacing';
import { bold, fontSize } from '@upright/ui/common/generic/utilities/fonts';
import styled from 'styled-components';

export function ShowColumnsSelector<T extends object>(props: { columns: Array<Column<T>> }) {
  return (
    <CustomTippyTooltip
      position="bottom"
      tooltipContent={
        <>
          {props.columns.map(column => {
            const headerDef = column.columnDef.header;

            /**
             * Currently we don't support rendering other than string headers in the column selector
             * If no string header is given in columnDef, we show the column id instead. If you need
             * to render something custom for a non-string header here, consider adding a separate property
             * in columnDef.meta to handle what's shown here in the column selector.
             */
            const headerElement = (() => {
              const headerString = column.columnDef.meta?.headerString;
              if (headerString) return headerString;
              if (typeof headerDef === 'string') return headerDef;
              return column.columnDef.id;
            })();

            /* TODO ML: Update this to check the column definition for "hideable flag"*/
            /* ..also flag the initial state, perhaps*/
            return (
              column.id !== 'EXPANDER_COLUMN_ID' && (
                <div key={column.id}>
                  <BouCheckBoxWithLabel
                    key={column.id}
                    label={headerElement}
                    onChange={() => {
                      column.toggleVisibility(!column.getIsVisible());
                    }}
                    checked={column.getIsVisible()}
                  />
                </div>
              )
            );
          })}
        </>
      }
    >
      <Root>
        <Text>Select columns to show</Text>
        <BouSvgIcon icon={<InterfaceArrowsButtonDown />} />
      </Root>
    </CustomTippyTooltip>
  );
}

const Root = styled.div`
  ${fontSize(-1)};
  font-weight: ${bold};
  color: ${BouColor.TOOL_TEXT_LIGHT_GRAY};
  &:hover {
    color: ${BouColor.TOOL_TEXT_GRAY};
    cursor: pointer;
  }
  display: flex;
  align-items: center;
`;

const Text = styled.div`
  ${fluidSpacing('margin-right', BouSpacingLevel.TINY)};
`;
